import { NgModule } from '@angular/core';

import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { SharedModule } from "../shared/shared.module";
import { Ng2DatetimePickerModule } from "ng2-datetime-picker/dist";
import { DashboardFilterComponent, HeaderMenuComponent, RevenueComponent, SambaEarningsComponent, PlayedViewComponent, YearlyRevenueComponent, ViewsComponent, ECPMComponent, CampaingChartComponent, UniquesByDayComponent, UniquesComponent } from "./dashboard-shared.index";

@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        SharedModule,
        Ng2DatetimePickerModule
    ],
    declarations: [
        DashboardFilterComponent,
        HeaderMenuComponent,
        RevenueComponent,
        SambaEarningsComponent,
        PlayedViewComponent,
        YearlyRevenueComponent,
        ViewsComponent,
        ECPMComponent,
        CampaingChartComponent,
        UniquesByDayComponent,
        UniquesComponent
    ],
    exports: [
        DashboardFilterComponent,
        HeaderMenuComponent,
        RevenueComponent,
        SambaEarningsComponent,
        PlayedViewComponent,
        YearlyRevenueComponent,
        ViewsComponent,
        ECPMComponent,
        CampaingChartComponent,
        UniquesByDayComponent,
        UniquesComponent
    ]
})
export class DashboardSharedModule { }



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard-shared.module.ts